// An address the app has no page for (Figma "Web · 404"). Not routed yet: it
// needs `<Route path="*" element={<NotFound />} />` as the last route in App.jsx.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ds";
import { AppStatePage, StatusPanel } from "./AuthLayout";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <AppStatePage>
      <StatusPanel icon="404" title="This page doesn’t exist" body="The link may be old, or the address mistyped.">
        <Button block onClick={() => navigate("/dashboard", { replace: true })}>Go to Today</Button>
      </StatusPanel>
    </AppStatePage>
  );
}
